import { getMeta, setMeta } from './db.ts';

/**
 * Stable per-install identity. Used to attribute events, to scope "which round should this
 * device resume", and to let a lost phone be identified for revocation.
 */
export async function deviceId(): Promise<string> {
  let id = await getMeta<string | null>('device_id', null);
  if (!id) {
    id = crypto.randomUUID();
    await setMeta('device_id', id);
  }
  return id;
}
